import { Box, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Color, FontStyle } from "../../constants";
import { parseDate, prettyDate } from "../../utils/utils";
import FettiLongInput from "../FettiLongInput";
import { setChatInput } from "../../utils/actionUtils";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChatInput from "./ChatInput";
import ChatMessage from "./ChatMessage";

const ChatPanel = ({ onSend }) => {
  const recipient = useSelector((state) => state.messages.recipient);
  const messages = useSelector((state) => state.messages);
  const containerRef = React.useRef(null);
  const scrollRef = React.useRef(null);
  const [containerHeight, setContainerHeight] = React.useState(0);
  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight);
      console.log("containerRef:", containerRef.current.clientHeight);
    }
  }, [containerRef]);
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView();
      // scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages.history]);
  return (
    <Stack
      direction="column"
      ref={containerRef}
      sx={{
        ...FontStyle.body,
        overflow: "hidden",
        height: "100%",
        width: "100%",
      }}>
      <Stack
        direction="column"
        sx={{
          flex: 1,
          // height: "100%",
          overflowY: "auto",
        }}>
        <Stack
          direction="column"
          spacing={1}
          sx={{
            px: 2,
            py: 2,
            // height: "100%",
            // flex: 1,
            // overflowY: "auto",
          }}>
          {messages.history.map((message, index) => {
            return (
              <ChatMessage
                message={message}
                key={index}
                prev={index > 0 ? messages.history[index - 1] : null}
              />
            );
          })}
          <Box ref={scrollRef} />
        </Stack>
      </Stack>
      <ChatInput containerHeight={containerHeight} onSend={onSend} />
    </Stack>
  );
};

export default ChatPanel;
